import { render, staticRenderFns } from "./DataBoard.vue?vue&type=template&id=3b048638&scoped=true"
import script from "./DataBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./DataBoard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DataBoard.vue?vue&type=style&index=0&id=3b048638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b048638",
  null
  
)

export default component.exports